
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.006 0C4.045 0 0 4.088 0 9.043 0 13.998 4.045 18 9.006 18S18 13.998 18 9.043C18 4.088 13.967 0 9.006 0zm-.024 1.56c.346 0 .628.125.9.422.273.296.507.823.72 1.502.137.44.312 1.192.403 1.752l-3.998.018c.091-.56.242-1.342.38-1.782.212-.679.49-1.206.761-1.503.272-.296.487-.41.834-.41zm-2.706.502c-.15.311-.238.604-.35.962-.192.612-.368 1.481-.474 2.212H2.55C3.411 3.8 4.685 2.655 6.276 2.062zm5.467.006c1.59.593 2.834 1.721 3.695 3.155l-2.89.043c-.106-.73-.282-1.63-.474-2.242-.112-.358-.181-.645-.331-.956zM1.89 6.795h3.404c-.056.778-.058 1.407-.058 2.248 0 .841.008 1.409.064 2.187l-3.416-.012a6.936 6.936 0 01-.341-2.175c0-.787.122-1.537.347-2.248zm4.976.006l4.298-.006c.065.786.057 1.371.057 2.248 0 .877.002 1.395-.063 2.181l-4.286-.006a23.22 23.22 0 01-.093-2.175c0-.877.023-1.456.087-2.242zm5.827-.025h3.429c.225.712.335 1.48.335 2.267a6.86 6.86 0 01-.341 2.163l-3.404.03c.056-.778.052-1.352.052-2.193s-.014-1.488-.07-2.267zM2.581 12.765h2.877c.106.73.276 1.685.468 2.297.112.358.206.571.356.883-1.59-.593-2.84-1.746-3.701-3.18zm4.439.006h3.99c-.09.56-.27 1.391-.408 1.83-.213.68-.466 1.14-.738 1.436-.272.297-.517.41-.864.41s-.568-.113-.84-.41c-.272-.296-.55-.756-.762-1.435-.137-.44-.288-1.271-.378-1.831zm5.54-.024l2.878.024c-.861 1.434-2.13 2.587-3.72 3.18.15-.311.244-.531.356-.889.192-.612.38-1.585.487-2.315z"}})])
          )
        }
      }
    